module.exports = __webpack_public_path__ + "img/towd_6.ae9ecd1a.jpg";